import { Field } from 'formik';
import { MutableRefObject, useRef } from 'react';
import AuthorsService from '../../common/API/AuthorsService';
import Input from '@/components/forms/Input';
import { Button } from '@/components/ui/button';
import FormFactory from '@/components/FormFactory';
import Screen from '@/components/layout/Screen';
import FloatingButton from '@/components/FloatingButton';
import { useData } from '@/common/hooks/useData';

const AuthorsAddScreen = () => {
  const formRef: MutableRefObject<any> = useRef();
  const { fetchAuthors } = useData();

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Add author',
          backBtnLabel: 'Authors',
          backBtnUrl: '/authors',
          titleClassName: 'text-white',
        },
      }}
      className='px-4 grid grid-rows-5'
    >
      <FormFactory className='row-span-4' formRef={formRef} initialValues={{ name: '' }}>
        <Field name='name' placeholder='Author name' component={Input} />
      </FormFactory>
      <div className='flex items-end'>
        <Button
          onClick={() => {
            AuthorsService.create(formRef.current.values).then((res) => {
              fetchAuthors();
            });
          }}
          className='w-full'
        >
          Save
        </Button>
      </div>
    </Screen>
  );
};

export default AuthorsAddScreen;
